module.exports = __webpack_public_path__ + "img/training-swim.21b9f539.svg";